const shouldUseWindowFetch = browserWindow => {
    if (!browserWindow) return false;
    if (browserWindow.__EXAM_SCRATCH_CONFIG__?.examMode === '1') return true;
    return /(?:^|[?&])hydro=1(?:&|$)/.test(browserWindow.location.search);
};

export default shouldUseWindowFetch;
